import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeOctagon extends Shape {
    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + (height * 3) / 10);
        canv.ctx.lineTo(x + (width * 3) / 10, y);
        canv.ctx.lineTo(x + (width * 7) / 10, y);
        canv.ctx.lineTo(x + width, y + (height * 3) / 10);
        canv.ctx.lineTo(x + width, y + (height * 7) / 10);
        canv.ctx.lineTo(x + (width * 7) / 10, y + height);
        canv.ctx.lineTo(x + (width * 3) / 10, y + height);
        canv.ctx.lineTo(x, y + (height * 7) / 10);
        canv.ctx.lineTo(x, y + (height * 3) / 10);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M17.5115 0.719836L17.5114 0.719756C17.3704 0.578736 17.1808 0.500075 16.9825 0.5L17.5115 0.719836ZM17.5115 0.719836L24.2802 7.48734L24.2803 7.48741M17.5115 0.719836L24.2803 7.48741M24.2803 7.48741C24.4209 7.62787 24.4999 7.81849 24.5 8.0175M24.2803 7.48741L24.5 8.0175M24.2802 17.5127L24.2803 17.5126C24.4209 17.3721 24.4999 17.1815 24.5 16.9825L24.2802 17.5127ZM24.2802 17.5127L17.5127 24.2802L17.5126 24.2803M24.2802 17.5127L17.5126 24.2803M17.5126 24.2803C17.3721 24.4209 17.1815 24.4999 16.9825 24.5M17.5126 24.2803L16.9825 24.5M7.4873 24.2802L7.48741 24.2803C7.62787 24.4209 7.81849 24.4999 8.0175 24.5L7.4873 24.2802ZM7.4873 24.2802L0.719803 17.5127L0.719756 17.5126M7.4873 24.2802L0.719756 17.5126M0.719756 17.5126C0.579112 17.372 0.500075 17.1814 0.5 16.9825M0.719756 17.5126L0.5 16.9825M0.719803 7.4873L0.719747 7.48736C0.579118 7.62794 0.500075 7.81863 0.5 8.0175L0.719803 7.4873ZM0.719803 7.4873L7.4873 0.719803L7.48736 0.719747M0.719803 7.4873L7.48736 0.719747M7.48736 0.719747C7.62794 0.579118 7.81863 0.500075 8.0175 0.5M7.48736 0.719747L8.0175 0.5M24.5 8.0175C24.5 8.01756 24.5 8.01763 24.5 8.01769M24.5 8.0175V8.01769M24.5 8.01769V16.9823V8.01769ZM16.9825 24.5C16.9824 24.5 16.9824 24.5 16.9823 24.5M16.9825 24.5H16.9823M16.9823 24.5H8.01769H16.9823ZM0.5 16.9825C0.5 16.9825 0.5 16.9824 0.5 16.9824M0.5 16.9825V16.9824M0.5 16.9824V8.01761V16.9824ZM8.0175 0.5C8.01754 0.5 8.01758 0.5 8.01761 0.5M8.0175 0.5H8.01761M8.01761 0.5H16.9824H8.01761Z"/>
            </svg>
        `;
    }
}
